module.exports = __webpack_public_path__ + "static/media/customer-service-left.00ad5985.png";